import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import LoadingAnimation from '@/shared/components/LoadingAnimation';
const LoadingContainer = ({ isLoading, children }) => isLoading ? _jsx(LoadingAnimation, {}) : _jsx(_Fragment, { children: children });
export default LoadingContainer;
